import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import Meta from "./../../pages/Meta";
import HotelintentData from "./hotelLocalData";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import DefaultHotelImage from "../../assets/images/intent-pages/hotel-default.png";
import presizeAudTar from "../../assets/images/hospitality/precise-audi-targ.png";
import leadCapture from "../../assets/images/lead-management/lead-capture.png";
import BannerHotelImage from "../../assets/images/intent-pages/hotel-location-banner.png";
import "../../assets/css/intent.css";

const HOTEL_IMAGES = [
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=800&q=80",
];

const LocationIcon = () => (
  <svg
    className="tw-text-slate-400 tw-flex-shrink-0"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="16"
    height="16"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: "4px",
    }}
  >
    <path
      fillRule="evenodd"
      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
      clipRule="evenodd"
    />
  </svg>
);

const HighlightCheckIcon = () => (
  <svg
    className="tw-flex-shrink-0 tw-text-[#10b981]"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="14"
    height="14"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: "6px",
    }}
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

const renderStars = (rating = 5) => {
  return (
    <div className="tw-flex tw-gap-0.5" style={{ margin: "4px 0" }}>
      {[...Array(rating)].map((_, i) => (
        <svg key={i} viewBox="0 0 20 20" fill="#FFC107" width="16" height="16">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
};

const SeoPage = () => {
  const totalNames = Object.keys(HotelintentData);

  const updateSEO = (title, description, keywords, ogImage) => {
    console.log("SEO Updated:", { title, description, keywords, ogImage });
  };

  const { slug } = useParams();
  const navigate = useNavigate();
  const [dataObject, setDataObject] = useState(null);
  const [printNeedBullets, setPrintNeedBullets] = useState([]);
  const [rightCrmPoints, setRightCrmPoints] = useState([]);
  const year = new Date().getFullYear();

  const shuffle = (array) => array.sort(() => Math.random() - 0.5);

  useEffect(() => {
    if (!totalNames.includes(slug)) {
      navigate("/404");
      return;
    }

    const data = HotelintentData[slug];
    setDataObject(data);
    setPrintNeedBullets(shuffle(data?.sectionTwo?.needBullets || []));
    setRightCrmPoints(data?.sectionThree || []);

    // Update SEO
    updateSEO(
      `India's Top Automated CRM Software for ${data?.name} in ${year}`,
      `${data?.description}`,
      `Best CRM Software for ${data?.name}`,
    );
  }, [slug, navigate]);

  const [showFloatingCta, setShowFloatingCta] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);
  const hotelsSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (hotelsSectionRef.current) {
        const rect = hotelsSectionRef.current.getBoundingClientRect();
        // Show floating button when the top of the hotels section has entered the screen
        setShowFloatingCta(rect.top <= 120);
      }

      const footer = document.querySelector("footer");
      const docHeight = document.documentElement.scrollHeight;
      const scrollPos = window.scrollY + window.innerHeight;
      const distToBottom = docHeight - scrollPos;
      const footerHeight = footer ? footer.offsetHeight : 350;

      // Hide the bar if we are near the bottom / footer
      setIsNearFooter(distToBottom < footerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dataObject]);

  if (!dataObject) return <p>Loading...</p>;

  return (
    <>
      <Meta
        title={`India's Top Automated CRM Software for ${dataObject.name} in ${year}`}
        description={dataObject.description}
      />

      <div className="tw-bg-[#fafbfe] tw-font-inter">
        {/* Hero Banner Section */}
        <section
          className="tw-relative tw-overflow-hidden tw-bg-white tw-pt-16 lg:tw-pt-24"
          id="hotel-seo-banner"
        >
          {/* Background Banner Image - Fit to screen width, aligned to bottom */}
          <img
            src={BannerHotelImage}
            alt={`Best hotels in ${dataObject.name}`}
            className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-auto tw-z-0 tw-block"
            loading="lazy"
          />

          <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-text-center tw-pb-[150px] sm:tw-pb-[220px] md:tw-pb-[280px] lg:tw-pb-[340px]">
            {/* Badge */}
            <div className="tw-inline-flex tw-items-center tw-gap-2 tw-mb-6 tw-px-3.5 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-[#5D44FF]/20 tw-bg-[#5D44FF]/5 tw-text-[#5D44FF] tw-text-xs tw-font-semibold tw-tracking-wide">
              🏨 Curated Destination Guide
            </div>

            {/* Title */}
            <h1 className="tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl tw-font-extrabold tw-tracking-tight tw-leading-[1.2] tw-mb-6 tw-text-slate-900 tw-max-w-4xl tw-mx-auto">
              Top Best Hotels in{" "}
              <span className="tw-text-[#5D44FF]">{dataObject.name}</span>
            </h1>

            {/* Description */}
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-mb-8 tw-max-w-3xl tw-mx-auto">
              {dataObject?.sectionOne}
            </p>

            {/* CTA Buttons */}
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-justify-center">
              <NavLink
                to="/signup"
                className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
              >
                Subscribe Now
              </NavLink>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        {/* Hotels Listing Section */}
        <section ref={hotelsSectionRef} className="tw-py-20 lg:tw-py-24 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
          <div className="tw-max-w-6xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
            {/* Section Header */}
            <div className="tw-text-center tw-mb-16">
              <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
                <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
                Luxury & Comfort
              </span>
              <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-4">
                Best Hotels in {dataObject.name} for Luxury, Comfort & Fine
                Dining
              </h2>
              <p className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-leading-relaxed tw-max-w-3xl tw-mx-auto">
                {dataObject?.sectionTwo?.text}
              </p>
            </div>

            {/* Hotels List */}
            <div className="tw-space-y-10">
              {dataObject?.sectionTwo?.hotels.map((hotel, index) => {
                const hotelImg =
                  hotel.image || HOTEL_IMAGES[index % HOTEL_IMAGES.length];
                const isPalace = hotel.averageCost.stay >= 20000;
                return (
                  <div
                    key={index}
                    className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-overflow-hidden tw-shadow-sm hover:tw-shadow-xl hover:tw-border-indigo-100 tw-transition-all tw-duration-300 tw-flex tw-flex-col lg:tw-flex-row"
                  >
                    {/* Left Image Section */}
                    <div className="tw-relative lg:tw-w-80 tw-flex-shrink-0 tw-h-64 lg:tw-h-auto tw-bg-slate-100">
                      <img
                        src={hotelImg}
                        alt={hotel.name}
                        className="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-500 hover:tw-scale-[1.04]"
                        loading="lazy"
                      />
                      <span
                        className={`tw-absolute tw-top-4 tw-left-4 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wide tw-px-3 tw-py-1 tw-rounded-full tw-backdrop-blur-md tw-shadow-sm ${
                          isPalace
                            ? "tw-bg-amber-100/90 tw-text-amber-800 tw-border tw-border-solid tw-border-amber-200"
                            : "tw-bg-indigo-50/90 tw-text-[#5D44FF] tw-border tw-border-solid tw-border-indigo-100"
                        }`}
                      >
                        {isPalace ? "Grand Luxury" : "Boutique Premium"}
                      </span>
                    </div>

                    {/* Right Content Section */}
                    <div className="tw-p-6 sm:tw-p-8 tw-flex-1 tw-flex tw-flex-col tw-justify-between">
                      <div>
                        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start tw-gap-2 tw-mb-2">
                          <h3 className="tw-text-xl sm:tw-text-2xl tw-font-extrabold tw-text-slate-800 tw-m-0">
                            {hotel.name}
                          </h3>
                          <div className="tw-flex tw-items-center tw-gap-1.5">
                            {renderStars(index % 3 === 0 ? 5 : 4)}
                            <span className="tw-text-xs sm:tw-text-sm tw-font-bold tw-text-slate-500 tw-mt-0.5">
                              {index % 3 === 0
                                ? (5.0 - (index % 2) * 0.1).toFixed(1)
                                : (4.8 - (index % 2) * 0.1).toFixed(1)}
                            </span>
                          </div>
                        </div>

                        <p className="tw-text-xs sm:tw-text-sm tw-text-slate-500 tw-flex tw-items-center tw-gap-1.5 tw-mb-4">
                          <LocationIcon /> {hotel.address}
                        </p>

                        {hotel.brief && (
                          <p className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4 tw-italic tw-border-l-4 tw-border-solid tw-border-[#5D44FF] tw-pl-4">
                            {hotel.brief}
                          </p>
                        )}

                        {hotel.highlights && hotel.highlights.length > 0 && (
                          <div className="tw-mb-5 tw-bg-slate-50 tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100">
                            <h4 className="tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-wider tw-mb-2">
                              Key Highlights
                            </h4>
                            <ul className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-2 tw-p-0 tw-m-0 tw-list-none">
                              {hotel.highlights.slice(0, 4).map((hl, hlIdx) => (
                                <li
                                  key={hlIdx}
                                  className="tw-text-xs sm:tw-text-sm tw-text-slate-600 tw-flex tw-items-center tw-gap-2"
                                >
                                  <HighlightCheckIcon /> {hl}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {/* Facilities Chips */}
                        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mb-6">
                          {hotel.facilities.map((facility, i) => (
                            <span
                              key={i}
                              className="tw-bg-slate-100 tw-border tw-border-solid tw-border-slate-200 tw-text-slate-600 tw-text-xs tw-font-semibold tw-px-3 tw-py-1 tw-rounded-full hover:tw-bg-slate-200 tw-transition-colors"
                            >
                              {facility}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* AI Automation Section */}
        <section className="tw-py-20 lg:tw-py-28 tw-bg-white tw-border-t tw-border-solid tw-border-slate-100">
          <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
            {/* Section Header */}
            <div className="tw-text-center tw-mb-20">
              <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
                <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
                Grow Direct Bookings
              </span>
              <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
                Need for AI-Powered Hotel Sales & Marketing Automation
              </h2>
              <p className="tw-text-sm sm:tw-text-base tw-text-slate-500 tw-leading-relaxed tw-max-w-4xl tw-mx-auto tw-mt-4">
                Hotels face increasing challenges in lead management, marketing
                automation, and guest engagement. BeyondLeadz, an AI-powered
                sales and marketing automation suite, leverages intelligent
                automation to streamline operations, optimize sales pipelines,
                and enhance guest experiences. By replacing manual,
                time-consuming processes with AI-driven efficiency, BeyondLeadz
                helps hotels maximize conversions and drive revenue growth.
                Here's how:
              </p>
            </div>

            {/* Automation Cards Alternating Layout */}
            <div className="tw-space-y-12">
              {/* Card 1 */}
              <div className="tw-bg-[#F8FCFF] tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  <div className="md:tw-col-span-7 tw-text-left md:tw-order-1">
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Solution 01
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      Lead Management – Capture, Nurture, Convert
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      Hotels receive numerous inquiries daily, and manually
                      managing them can lead to lost revenue. BeyondLeadz
                      automates lead capture, scoring, and follow-ups, ensuring
                      that sales teams focus on high-value prospects. <br />
                      <br />
                      AI-powered lead prioritization increases conversion rates,
                      while automated responses keep guests engaged. This
                      feature helps hotels handle more inquiries efficiently and
                      maximize revenue opportunities.
                    </p>
                  </div>
                  <div className="md:tw-col-span-5 tw-flex tw-justify-center md:tw-order-2">
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={leadCapture}
                        alt="Lead Management"
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="tw-bg-[#F8FCFF] tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  <div className="md:tw-col-span-7 tw-text-left md:tw-order-2">
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Solution 02
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      Web-to-Lead – Convert Website Visitors into Guests
                      Instantly
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      A hotel’s website should be a powerful lead-generation
                      tool. BeyondLeadz captures visitor data automatically,
                      turning inquiries into actionable leads. Instant
                      notifications ensure sales teams respond quickly, and
                      seamless CRM integration organizes lead data efficiently.{" "}
                      <br />
                      <br />
                      With reduced response time and structured follow-ups,
                      hotels can increase their direct bookings and reduce
                      dependency on third-party platforms.
                    </p>
                  </div>
                  <div className="md:tw-col-span-5 tw-flex tw-justify-center md:tw-order-1">
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={presizeAudTar}
                        alt="Web to Lead"
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 3 */}
              <div className="tw-bg-[#F8FCFF] tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  <div className="md:tw-col-span-7 tw-text-left md:tw-order-1">
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Solution 03
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      Multi-Channel Campaign Management
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      Launch and manage marketing campaigns across various
                      channels, including email, social media, and SMS.
                      BeyondLeadz ensures consistent messaging across all
                      platforms, helping you reach potential guests wherever
                      they are most active.
                    </p>
                  </div>
                  <div className="md:tw-col-span-5 tw-flex tw-justify-center md:tw-order-2">
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={presizeAudTar}
                        alt="Multi-Channel Campaign"
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 4 */}
              <div className="tw-bg-[#F8FCFF] tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  <div className="md:tw-col-span-7 tw-text-left md:tw-order-2">
                    <div className="tw-inline-block tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-mb-3">
                      Solution 04
                    </div>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      Automated Email Campaigns
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      Set up automated email workflows to nurture leads
                      throughout their decision-making process. From welcome
                      emails to post-stay follow-ups, BeyondLeadz enables you to
                      stay connected with your guests, increasing the likelihood
                      of repeat bookings.
                    </p>
                  </div>
                  <div className="md:tw-col-span-5 tw-flex tw-justify-center md:tw-order-1">
                    <div className="tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-2 tw-border tw-border-solid tw-border-slate-100 tw-shadow-sm hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={presizeAudTar}
                        alt="Automated Emails"
                        className="tw-max-w-full tw-h-auto tw-object-contain tw-rounded-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Static CTA Button Block */}
        <div className="tw-py-16 tw-text-center">
          <NavLink
            to="/contact-us"
            className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-5 sm:tw-px-8 tw-py-2.5 sm:tw-py-3 tw-bg-gradient-to-r tw-from-[#5D44FF] tw-to-[#7C3AED] hover:tw-from-[#4F46E5] hover:tw-to-[#6D28D9] tw-text-white tw-font-bold tw-text-xs sm:tw-text-sm tw-rounded-full tw-shadow-[0_10px_25px_rgba(93,68,255,0.35)] hover:tw-shadow-[0_15px_30px_rgba(93,68,255,0.5)] tw-transition-all tw-duration-300 hover:tw-scale-[1.05] tw-whitespace-nowrap tw-gap-2"
          >
            <span>
              <span className="tw-hidden sm:tw-inline">Need more information?</span>
              <span className="sm:tw-hidden">Need info?</span> Click here
            </span>
            <span className="tw-text-lg">💬</span>
          </NavLink>
        </div>
      </div>

      {/* Floating CTA Bottom Bar */}
      {showFloatingCta && !isNearFooter && (
        <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-50 tw-bg-white/85 tw-backdrop-blur-md tw-py-2.5 tw-border-t tw-border-solid tw-border-slate-100 tw-flex tw-justify-center tw-transition-all tw-duration-300 tw-shadow-[0_-5px_15px_rgba(0,0,0,0.03)]">
          <NavLink
            to="/contact-us"
            className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-5 sm:tw-px-8 tw-py-2.5 sm:tw-py-3 tw-bg-gradient-to-r tw-from-[#5D44FF] tw-to-[#7C3AED] hover:tw-from-[#4F46E5] hover:tw-to-[#6D28D9] tw-text-white tw-font-bold tw-text-xs sm:tw-text-sm tw-rounded-full tw-shadow-[0_10px_25px_rgba(93,68,255,0.35)] hover:tw-shadow-[0_15px_30px_rgba(93,68,255,0.5)] tw-transition-all tw-duration-300 hover:tw-scale-[1.05] tw-whitespace-nowrap tw-gap-2"
          >
            <span>
              <span className="tw-hidden sm:tw-inline">Need more information?</span>
              <span className="sm:tw-hidden">Need info?</span> Click here
            </span>
            <span className="tw-text-lg">💬</span>
          </NavLink>
        </div>
      )}
    </>
  );
};

export default SeoPage;
